import { RenderQuoteStatus } from '../../../../../../app/erp/screens/Logistic/QuoteParent/subcomponents'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import { TableComponentBaseScreenInnerProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, CustomRenderDate } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import locations from '../../../../../../utils/globals/locations'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { WorkSheetProductModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProduct'

type TableProductWorkSheetsProps = TableComponentBaseScreenInnerProps & {}

const TableProductWorkSheets: React.FC<TableProductWorkSheetsProps> = ({ setOpened, setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const workSheetStatusDict: TwinDictionary = {
        0: { name: t('working', 'Trabajando'), id: 0 },
        1: { name: t('finished', 'Finalizado'), id: 1 },
    }
    const columns: ColumnTableSchema<WorkSheetProductModelType> = [
        {
            id: 'WorkSheetId',
            dataKey: 'WorkSheetId',
            label: t('workSheet', 'Hoja de trabajo'),
            sortable: true,
            minWidth: 150,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.full_assigned_number} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('workSheet', 'Hoja de trabajo') }
            },
        },
        {
            id: 'custom_name',
            dataKey: 'WorkSheetId',
            label: t('name', 'Nombre'),
            simpleLabel: t('custom_name', 'Nombre personalizado'),
            sortable: true,
            minWidth: 120,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('custom_name', 'Nombre personalizado') }
            },
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.custom_name} />,
        },
        {
            id: 'CustomerId',
            dataKey: 'WorkSheetId',
            label: t('customer', 'Clientes'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.Customer?.fiscal_name || allRowData?.WorkSheet?.Customer?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('customer', 'Cliente') }
            },
            searchKey: 'Order.Customer.name',
        },
        {
            id: 'status',
            dataKey: 'WorkSheetId',
            label: t('status', 'Estado'),
            minWidth: 140,
            sortable: true,
            customRender: (parameterValue, allRowData) => <RenderQuoteStatus value={allRowData?.WorkSheet?.status} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelect',
                extraComponentData: { items: workSheetStatusDict, label: t('statusQuote', 'Estado del presupuesto') }

            },
        },
        {
            id: 'WorkingCenterId',
            dataKey: 'WorkSheetId',
            searchKey: 'WorkingCenter.name',
            minWidth: 115,
            label: t('workingCenter', 'Centro de trabajo'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.WorkingCenter?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('workingCenter', 'Centro de trabajo') }
            },
            hideColumnByDefault: true
        },
        {
            id: 'processed_date',
            dataKey: 'WorkSheetId',
            label: t('createdDate', 'Fecha de creación'),
            minWidth: 165,
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={allRowData?.WorkSheet?.processed_date || allRowData?.WorkSheet?.createdAt} className={parameterValue ? '' : 'text-red-BA'} />,
            sortable: true,
            hideColumnByDefault: true
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            sortable: true,
        },
        {
            id: 'SellOrderId',
            dataKey: 'WorkSheetId',
            label: t('sellOrderShort', 'Pedido'),
            sortable: true,
            minWidth: 50,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.SellOrder?.full_assigned_number || allRowData?.WorkSheet?.SellOrderId} />,
        },
        {
            id: 'SellDeliveryNoteId',
            dataKey: 'WorkSheetId',
            label: t('sellDeliveryNoteShort', 'Albarán'),
            sortable: true,
            minWidth: 50,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.SellDeliveryNote?.full_assigned_number || allRowData?.WorkSheet?.SellDeliveryNoteId} />,
        },
        {
            id: 'SellInvoiceId',
            dataKey: 'WorkSheetId',
            label: t('sellInvoiceShort', 'Factura'),
            sortable: true,
            minWidth: 50,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkSheet?.SellInvoice?.full_assigned_number || allRowData?.WorkSheet?.SellInvoiceId} />,
        },
    ]
    return (
        <TwinTableLink createRowDataLink={[locations.workSheetSingle, ['$WorkSheetId']]} columns={columns} name='productWorkSheets' getDataFrom='/api/app/order/sell/workSheet/workSheetProduct/getAllWorkSheetProductsByProductId'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData,
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams}
        >
        </TwinTableLink>
    )
}

export default TableProductWorkSheets